import classSet from 'classnames';
import React from 'react';
import { withRouter } from 'react-router-dom';

@withRouter
class Folder extends React.Component {
  static defaultProps = {
    name: '',
    files: [],
    childFolders: {}
  };

  state = {
    isExpanded: this.props.isExpanded || false,
    action: this.props.action || 'view'
  };

  toggleExpand = () => {
    return this.setState({ isExpanded: !this.state.isExpanded });
  };

  render() {
    let children;
    const cx = classSet({
      fa: true,
      'fa-folder': !this.state.isExpanded,
      'fa-folder-open': this.state.isExpanded
    });
    let folderClass = '';
    if (this.state.isExpanded) {
      folderClass = 'folder-open';
      children = <ul className="bz-sub-file-tree">{this.props.childFolders}</ul>;
    }
    return (
      <li className={folderClass}>
        <div onClick={this.toggleExpand}>
          <i className={cx} />
          {this.props.name}
        </div>
        {children}
      </li>
    );
  }
}

export default Folder;
